<template>
	<div class="file-list-view">
		<div class="file" v-for="(file, i) in value" v-bind:key="i" @click="open(file.id)">
			{{ file.label }}
			<div>
				<div @click.stop="rename(file)">Omdøb</div>
				<div @click.stop="del(i)">Slet</div>
			</div>
		</div>
		<div class="btn" @click="select">Upload</div>
		<input type="file" ref="file" @change="change" />
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		methods: {
			del(i) {
				this.value.splice(i, 1);
			},
			rename(file) {
				var name = prompt('Navn', file.label);

				if (name == '') return;

				file.label = name;
			},
			select() {
				this.$refs.file.click();
			},
			change(e) {
				console.log(e.target);

				this.upload(e);
			},
			upload(e) {
				console.log('upload');

				var self = this;

				var formData = new FormData();
				formData.append('file', e.target.files[0]);

				this.axios
					.post('/storage/', formData)
					.then(function (r) {
						console.log(r.data);

						self.value.push({
							id: r.data,
							label: 'Ny fil - ' + (new Date()).format('Y-m-d')
						});
					});
			},
			open(file) {
				this.axios
					.get('/storage/urls/' + file + '/')
					.then(function (r) {
						console.log(r.data);

						window.open(r.data, '_blank');
					});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.file-list-view {
		overflow: hidden;

		& > input {
			position: absolute;
			left: -500px;
		}

		& > .file {
			position: relative;
			border: 1px solid #2d2f36;
			line-height: 40px;
			text-align: left;
			padding-left: 10px;
			margin-bottom: 10px;
			cursor: pointer;

			& > div {
				position: absolute;
				top: 0;
				right: 0;

				& > div {
					display: inline-block;
					margin-right: 15px;
					font-size: 12px;
				}
			}
		}

		& > .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}
	}
</style>